export default "__VITE_ASSET__BtAlwbeb__"